{
    "NAME": "Liste des journaux de modifications de configurationLangue",
    "ConfigChangeLogList_Column_Description": "Description",
    "ConfigChangeLogList_Column_DateTime": "Date\/Heure",
    "ConfigChangeLogList_Column_User": "Utilisateur",
    "ConfigChangeLogList_Column_Action": "Action",
    "ConfigChangeLogList_Column_Type": "Taper",
    "ConfigChangeLogList_Column_CME": "Formation médicale continue",
    "ConfigChangeLogList_Column_TelSys": "Serveur de téléphonie",
    "ConfigChangeLogList_Column_Partition": "Partition",
    "ConfigChangeLogList_Filter_Before": "Avant",
    "ConfigChangeLogList_Filter_Actions": "Actes",
    "ConfigChangeLogList_Filter_EntityTypes": "Types d'entités",
    "ConfigChangeLogList_Filter_MultiSelectedCount": "[{} sélectionné]",
    "ConfigChangeLogList_Filter_SearchUsername": "Nom d'utilisateur de recherche",
    "ConfigChangeLogList_Filter_SuppressNulls": "Supprimer les valeurs nulles",
    "ConfigChangeLogList_Filter_SuppressNulls_No": "Non",
    "ConfigChangeLogList_Filter_SuppressNulls_Yes": "Oui",
    "ConfigChangeLogList_Filter_ActionDescription_All": "[Tous]",
    "ConfigChangeLogList_Filter_ActionDescription_INSERT": "Insérer",
    "ConfigChangeLogList_Filter_ActionDescription_UPDATE": "Mise à jour",
    "ConfigChangeLogList_Filter_ActionDescription_DELETE": "Supprimer",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN": "Se connecter",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_FAILED": "La connexion a échoué",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_AS": "Se connecter en tant que",
    "ConfigChangeLogList_Filter_ActionDescription_SYNC_REQUESTED": "Synchronisation demandée",
    "ConfigChangeLogList_Filter_TypeDescription_All": "[Tous]",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgents": "Agents ACD",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgentsOwned": "agents ACD propriétaires (adhésions)",
    "ConfigChangeLogList_Filter_TypeDescription_Devices": "Appareils",
    "ConfigChangeLogList_Filter_TypeDescription_DevicesOwned": "Appareils possédés (abonnements)",
    "ConfigChangeLogList_Filter_TypeDescription_DNISAssociations": "Associations DNIS",
    "ConfigChangeLogList_Filter_TypeDescription_Codes": "Codes",
    "ConfigChangeLogList_Filter_TypeDescription_CallRecordingIntegrations": "Intégrations d'enregistrement des appels",
    "ConfigChangeLogList_Filter_TypeDescription_Partitions": "Cloisons",
    "ConfigChangeLogList_Filter_TypeDescription_TelephoneSystems": "Systèmes téléphoniques",
    "ConfigChangeLogList_Filter_TypeDescription_Users": "Utilisateurs",
    "ConfigChangeLogList_Filter_TypeDescription_CRMConfiguration": "Configuration CRM",
    "ConfigChangeLogList_Detail_Title": "entrée de journal d'audit",
    "ConfigChangeLogList_Detail_SummaryColumnItem": "Article",
    "ConfigChangeLogList_Detail_SummaryColumnValue": "Valeur",
    "ConfigChangeLogList_Detail_Field": "Champ",
    "ConfigChangeLogList_Detail_OldValue": "ancienne valeur",
    "ConfigChangeLogList_Detail_NewValue": "Nouvelle valeur"
}